var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetrics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.612,
    height: 26.2,
    viewBox: "0 0 19.612 26.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-90.9 -34.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.057,61a.353.353,0,0,0,.355-.351v-20.7a.353.353,0,0,0-.007-.066v0a.353.353,0,0,0-.018-.061v0a.347.347,0,0,0-.029-.055l0,0a.361.361,0,0,0-.038-.048l0,0-4.418-4.6,0,0-.014-.013-.011-.01-.017-.013-.01-.008-.024-.015,0,0a.351.351,0,0,0-.17-.043H91.355a.353.353,0,0,0-.355.351v25.3a.353.353,0,0,0,.355.351ZM106,36.228l3.228,3.36H106Zm-14.294-.522h13.588v4.242a.34.34,0,0,0,.345.346h4.067v20h-18Z",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.028,395H143.839a.353.353,0,1,0,0,.706h12.189a.353.353,0,1,0,0-.706Z",
    transform: "translate(-49.399 -338.824)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.486,344.353a.353.353,0,0,0,.353.353H150.9a.353.353,0,1,0,0-.706h-7.061A.353.353,0,0,0,143.486,344.353Z",
    transform: "translate(-49.399 -290.824)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.412,226.353a.353.353,0,0,0-.353-.353h-1.706a.353.353,0,0,0-.353.353v3.353a.353.353,0,0,0,.353.353h1.706a.353.353,0,0,0,.353-.353Zm-1.706.353h1.059v2.647h-1.059Z",
    transform: "translate(-97.882 -179.765)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.412,201.353a.353.353,0,0,0-.353-.353h-1.706a.353.353,0,0,0-.353.353v4.824a.353.353,0,0,0,.353.353h1.706a.353.353,0,0,0,.353-.353Zm-.706,4.471h-1v-4.118h1Z",
    transform: "translate(-157.176 -156.235)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.412,251.353a.353.353,0,0,0-.353-.353h-1.706a.353.353,0,0,0-.353.353v1.882a.353.353,0,0,0,.353.353h1.706a.353.353,0,0,0,.353-.353Zm-.706,1.529h-1v-1.176h1Z",
    transform: "translate(-39.529 -203.294)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.892,119.5l2.4,2.108a.353.353,0,0,0,.45.013l3.817-2.982-.138,1.788a.353.353,0,0,0,.325.379h.027a.353.353,0,0,0,.352-.326l.2-2.569a.353.353,0,0,0-.327-.379l-2.766-.2a.353.353,0,0,0-.05.7l1.832.131-3.473,2.714-2.42-2.129a.353.353,0,0,0-.477.01l-2.832,2.717a.353.353,0,1,0,.489.509Z",
    transform: "translate(-32.656 -77.489)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetrics);
export default __webpack_public_path__ + "static/media/metrics.1b8ff0e8.svg";
export { ForwardRef as ReactComponent };